/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import cx from 'classnames';
import { PopUpMobile } from '@bwoty-web/styleguide';
import { Link, Icon } from '@bwoty-web/ui-kit';
import { UI_CHEVRON_DOWN, UI_CHEVRON_UP } from '@bwoty-web/ui-kit/icons';
import { logGeoInformation } from '../utils/log';
import { scrollUpToElementIfNeeded } from '../utils/elements';
import Paragraph from './paragraph';
import './description.scss';

const Description = ({
  paragraphs,
  mobileHeading,
  geoType,
  showMoreText,
  hideText,
  officialHotelRatingParagraph,
  className,
  isAlwaysExpanded,
  isNewGlobetrotter,
}) => {
  const [isExpanded, setIsExpanded] = useState(isAlwaysExpanded);

  if (paragraphs?.length < 1) {
    return null;
  }

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
    logGeoInformation.clickOnMoreAbout(isExpanded, geoType);
    const [containerElement] =
      document.getElementsByClassName('gw-description');
    scrollUpToElementIfNeeded(containerElement);
  };

  let isMobile = false;

  if (typeof window !== 'undefined') {
    isMobile = window?.innerWidth < 768;
  }

  const expandedMobile = isMobile && isExpanded;

  const content = (
    <div className="gw-description__paragraphs">
      {paragraphs.map((paragraph) => {
        return (
          <Paragraph
            paragraph={paragraph}
            isExpanded={isExpanded}
            key={uniqid('description-paragraph-')}
          />
        );
      })}
      {officialHotelRatingParagraph && (
        <Paragraph
          paragraph={officialHotelRatingParagraph}
          isExpanded={isExpanded}
          key={uniqid('description-paragraph-')}
        />
      )}
    </div>
  );

  const expandLinkIcon = (
    <Icon path={isExpanded ? UI_CHEVRON_UP : UI_CHEVRON_DOWN} />
  );

  return (
    <div
      className={cx(className, 'gw-description', {
        'gw-description--globetrotter': isNewGlobetrotter,
      })}
    >
      {content}
      {!isAlwaysExpanded && paragraphs?.length > 1 && (
        <div className="gw-description__expand-link">
          <Link iconAfter={expandLinkIcon} onClick={() => handleExpand()}>
            {isExpanded ? `${hideText}` : `${showMoreText}`}
          </Link>
        </div>
      )}
      {!isAlwaysExpanded && expandedMobile && (
        <PopUpMobile
          className="gw-description__pop-up"
          header={mobileHeading}
          close={() => handleExpand()}
          closed={!isExpanded}
          closeBottom
        >
          <div className="gw-description__pop-up-content">{content}</div>
        </PopUpMobile>
      )}
    </div>
  );
};

Description.propTypes = {
  paragraphs: PropTypes.arrayOf(
    PropTypes.shape({
      mobile: PropTypes.string,
      desktop: PropTypes.string,
      expanded: PropTypes.string,
      heading: PropTypes.string,
    }),
  ).isRequired,
  showMoreText: PropTypes.string.isRequired,
  hideText: PropTypes.string.isRequired,
  geoType: PropTypes.string.isRequired,
  mobileHeading: PropTypes.node.isRequired,
  officialHotelRatingParagraph: PropTypes.shape({
    mobile: PropTypes.string,
    desktop: PropTypes.string,
    expanded: PropTypes.string,
  }),
  className: PropTypes.string,
  isAlwaysExpanded: PropTypes.bool,
  isNewGlobetrotter: PropTypes.bool,
};

Description.defaultProps = {
  officialHotelRatingParagraph: null,
  className: null,
  isAlwaysExpanded: false,
  isNewGlobetrotter: false,
};

export default Description;
